'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isFetched = exports.isFetched = function isFetched(resource) {
  return resource && resource.get('fetched') || false;
};
var isFetching = exports.isFetching = function isFetching(resource) {
  return resource && resource.get('fetching') || false;
};
var isError = exports.isError = function isError(resource) {
  return resource && resource.get('hasError') && !isFetching(resource);
};

/**
 * If:
 * - we're not currently fetching, and
 * - we're forcing a fetch, or, we haven't fetched the element
 * Then we should fetch the element.
 */
var shouldFetchResource = exports.shouldFetchResource = function shouldFetchResource(force, resource) {
  return !isFetching(resource) && (force || !isFetched(resource));
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/resources/resourceUtil.js
// module id = 108
// module chunks = 0